import { signal, Signal } from '@preact/signals';

export class AdContextStore {
  static _instance?: AdContextStore;

  static getInstance(): AdContextStore {
    return AdContextStore._instance!;
  }

  static createInstance(adContext: AdContext): AdContextStore {
    if (AdContextStore._instance) {
      return AdContextStore._instance;
    }

    AdContextStore._instance = new AdContextStore(adContext);
    return AdContextStore._instance;
  }

  _adContext: Signal<AdContext> = signal({} as AdContext);

  constructor(adContext: AdContext) {
    this._adContext.value = adContext;
  }

  // eslint-disable-next-line flowtype-errors/show-errors
  get adContext() {
    return this._adContext.value;
  }
}
